import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";

export async function getUsers({
    merchantId, phoneNumber, page, limit
}) {
    try {
        let response = await axios.Get({
            url: `${adminUrl}/users`,
            params: {
                merchantId: merchantId || null,
                phoneNumber: phoneNumber || '',
                page,
                limit
            }
        })
        if (response.statusCode !== 200) { return { error: response.message };}
        return { data: response.data }
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function searchUserByPhone(phoneNumber) {
    try {
        let response = await axios.Get({
            url: `${adminUrl}/user`,
            params: {
                phoneNumber: phoneNumber || ''
            }
        })
        if (response.statusCode !== 200) { return { error: response.message };}
        return { data: response.data}
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function createUserServiceRole(body) {
    try {
        let response = await axios.Post({
            url: `${adminUrl}/user-service-role/create`,
            data: body
        })
        if (response.statusCode !== 200) { return { error: response.message };}
        return { data: response.data }
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function updateUserServiceRole(body) {
    try {
        let response = await axios.Post({
            url: `${adminUrl}/user-service-role/update`,
            data: body
        })
        if (response.statusCode !== 200) { return { error: response.message };}
        return { data: response.data }
    } catch (e) {
        return { error: e.response.data };
    }
}